import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';
import { Certificate } from '@/react/edge/components/types';

export interface EndpointMTLSCertificateResponse {
  MTLSCertificate?: Certificate;
}

async function getEndpointMTLSCertificates(environmentId: number) {
  try {
    const { data } = await axios.get<EndpointMTLSCertificateResponse>(
      `/endpoints/${environmentId}/mtls_certificate`
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error as Error);
  }
}

export function useEndpointMTLSCertificate(
  environmentId: number,
  refetchInterval: number = 5000
) {
  return useQuery(
    ['endpoints', environmentId, 'mtls_certificate'],
    () => getEndpointMTLSCertificates(environmentId),
    {
      ...withError('Unable to get endpoint MTLS Certificate'),
      refetchInterval(data) {
        if (data?.MTLSCertificate) {
          return false;
        }
        return refetchInterval;
      },
    }
  );
}
